import { Linkedin, Instagram, Youtube, Facebook } from 'lucide-react';
import { TikTokIcon } from '@/components/ui/TikTokIcon';
import type { Channel } from '@/services/business/calendar';

/**
 * Returns the icon component for a given channel
 */
export function getChannelIcon(channel: Channel) {
  switch (channel) {
    case 'linkedin':
      return Linkedin;
    case 'instagram':
      return Instagram;
    case 'tiktok':
      return TikTokIcon;
    case 'youtube':
      return Youtube;
    case 'facebook':
      return Facebook;
  }
}

/**
 * Returns the display label for a given channel
 */
export function getChannelLabel(channel: Channel): string {
  switch (channel) {
    case 'linkedin':
      return 'LinkedIn';
    case 'instagram':
      return 'Instagram';
    case 'tiktok':
      return 'TikTok';
    case 'youtube':
      return 'YouTube';
    case 'facebook':
      return 'Facebook';
  }
}

